import React from 'react';

import { Box, Button, Typography, useTheme } from '@mui/material';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { useBreakpointV3 } from '@helpers/use';
import { IDegreeLandingPageData } from '@interfaces/university';

type AnnouncementDegreeProps = {
  degreeAlertFlag: IDegreeLandingPageData['degreeAlertFlag'];
};

const AnnouncementDegree = ({ degreeAlertFlag }: AnnouncementDegreeProps) => {
  const theme = useTheme();
  const { isMobile } = useBreakpointV3();

  const { title, description, buttonText, buttonLink } = degreeAlertFlag;

  const onOpenNewTab = () => {
    window.open(buttonLink, '_blank');
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        py: '16px',
        px: { xs: '24px', sm: '24px', lg: '152px' },
        gap: { xs: '16px', sm: '16px', md: '40px' },
        backgroundColor: theme.palette.warning.light,
      }}
    >
      <Box sx={{ display: 'flex', width: 'auto', gap: { xs: '16px', sm: '16px', md: '24px' }, whiteSpace: 'pre-wrap' }}>
        <FontAwesomeIcon
          sx={{ color: theme.palette.textV2.disabled, fontSize: { md: '40px', sm: '32px' } }}
          icon="fa-light fa-circle-info"
        />
        <Box sx={{ width: '-webkit-fill-available' }}>
          <Typography variant={isMobile ? 'h6' : 'h5'}>{title}</Typography>
          <Typography sx={{ fontFamily: 'lanna' }} variant={isMobile ? 'body2' : 'body1'}>
            {description}
          </Typography>
        </Box>
      </Box>
      {buttonLink && (
        <Box
          sx={{
            display: 'flex',
            width: isMobile ? '100%' : '170px',
          }}
        >
          <Button
            sx={{
              display: 'flex',
              width: isMobile ? '100%' : '170px',
              gap: '8px',
              backgroundColor: theme.palette.common.white,
              textTransform: 'unset',
            }}
            variant="outlined"
            color="primary"
            onClick={onOpenNewTab}
          >
            <Typography variant="button">{buttonText}</Typography>
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default AnnouncementDegree;
